import { Component, inject } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { IButtonComponent, IInputComponent, MODAL_DATA, ModalRef } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

export interface InputModalData {
  title?: string;
  maxLength?: number;
  initialValue?: string;
}

@Component({
  selector: "app-input-modal",
  templateUrl: "./input-modal.component.html",
  styleUrls: ["./input-modal.component.scss"],
  standalone: true,
  imports: [TranslocoDirective, ReactiveFormsModule, IButtonComponent, IInputComponent],
})
export class InputModalComponent {
  data = inject(MODAL_DATA) as InputModalData;
  ref = inject(ModalRef);

  value: string = this.data.initialValue ?? "";

  update() {
    this.ref.close(this.value);
  }
}
